// extracted by mini-css-extract-plugin
export default {"container":"SuccessAlert_container__UY8Bw"};